/* ==========================================================================
   Start Nutra · Science "Story" scrollytelling driver (STILL NIGHT, 10 beats)
   --------------------------------------------------------------------------
   A single continuous camera scrubbed from scroll position. We ONLY read scroll,
   never hijack/lock/scroll-jack; native scroll speed is preserved.

   - A rAF-throttled scroll handler writes ONE global progress var --p (0..1)
     across the tall scroller. All camera motion (push-in -> hold -> pull-back)
     and every object's transform/opacity is a CONTINUOUS function of --p in
     CSS (calc + clamp over sub-ranges), so beats share position/scale and
     objects persist and transform across beats, no hard cuts, no random slides.
   - It also sets the active beat index (for the synced captions) and ticks any
     dose counters to their exact values across their own --p sub-range.
   - Enhanced only when (min-width: 1024px) AND motion allowed: we add
     `.sn-story-ready` and run the driver; otherwise the CSS static stacked
     fallback stands (re-evaluated on resize / rotation).
   Vanilla JS, no dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var mq = window.matchMedia
    ? window.matchMedia('(min-width: 1024px) and (prefers-reduced-motion: no-preference)')
    : { matches: false, addEventListener: null, addListener: null };

  function initOne(root) {
    var scroller = root.querySelector('.sn-story__scroller');
    var captions = Array.prototype.slice.call(root.querySelectorAll('[data-story-caption]'));
    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-st-count]'));
    var beatsCount = parseInt(root.getAttribute('data-story-beats'), 10) || 10;
    if (!scroller) return;

    // Optional per-beat --p thresholds so captions switch on the SAME windows the
    // CSS crossfades use (not a naive floor(p * beats), which drifts from the
    // custom-paced beats/holds). Falls back to even division if absent/invalid.
    var thresholds = (root.getAttribute('data-story-thresholds') || '')
      .split(',')
      .map(function (v) { return parseFloat(v); })
      .filter(function (v) { return !isNaN(v); });

    function beatFor(p) {
      if (thresholds.length) {
        var i = 0;
        for (var t = 0; t < thresholds.length; t++) { if (p >= thresholds[t]) i = t; }
        return i;
      }
      return Math.min(Math.floor(p * beatsCount), beatsCount - 1);
    }

    var enhanced = false;
    var ticking = false;
    var activeBeat = -1;

    function setActive(i) {
      if (i === activeBeat) return;
      activeBeat = i;
      for (var c = 0; c < captions.length; c++) {
        var ci = parseInt(captions[c].getAttribute('data-story-caption'), 10);
        captions[c].classList.toggle('is-active', ci === i);
      }
    }

    function tickCounters(p) {
      for (var k = 0; k < counters.length; k++) {
        var el = counters[k];
        var to = parseFloat(el.getAttribute('data-st-count')) || 0;
        var p0 = parseFloat(el.getAttribute('data-p0'));
        var p1 = parseFloat(el.getAttribute('data-p1'));
        var unit = el.getAttribute('data-unit') || '';
        if (isNaN(p0) || isNaN(p1) || p1 <= p0) { el.textContent = to + unit; continue; }
        var prog = Math.min(Math.max((p - p0) / (p1 - p0), 0), 1);
        el.textContent = Math.round(to * prog) + unit;
      }
    }

    function update() {
      ticking = false;
      if (!enhanced) return;
      var rect = scroller.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = scroller.offsetHeight - vh;
      var p = 0;
      if (total > 0) p = Math.min(Math.max(-rect.top, 0), total) / total;
      root.style.setProperty('--p', p.toFixed(5));
      setActive(beatFor(p));
      tickCounters(p);
    }

    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

    function enable() {
      if (enhanced) return;
      enhanced = true;
      root.classList.add('sn-story-ready');
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function disable() {
      if (!enhanced) return;
      enhanced = false;
      root.classList.remove('sn-story-ready');
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      root.style.removeProperty('--p');
      activeBeat = -1;
      setActive(0);
      tickCounters(1); // fallback: show exact final dose values
    }

    function evaluate() { if (mq.matches) enable(); else disable(); }

    evaluate();
    if (mq.addEventListener) mq.addEventListener('change', evaluate);
    else if (mq.addListener) mq.addListener(evaluate);
  }

  function init() {
    var roots = document.querySelectorAll('[data-story]');
    Array.prototype.forEach.call(roots, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
